import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { NavigationService } from '../core/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class PendingCognitoGuard {
  constructor(private auth_service: AuthService, private navigation_service: NavigationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const pending_cognito = this.auth_service.pending_cognito_user;
    if (pending_cognito) {
      return true;
    } else {
      this.navigation_service.toAuthSignin();
      return false;
    }
  }
}
